import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12.5",
      cy: "12.7",
      r: "11.6",
      class: "st0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.5 5.6c-3.9 0-7.1 3.2-7.1 7.1s3.2 7.1 7.1 7.1 7.1-3.2 7.1-7.1-3.2-7.1-7.1-7.1m0 13.2c-3.4 0-6.2-2.8-6.2-6.2s2.8-6.2 6.2-6.2 6.2 2.8 6.2 6.2-2.8 6.2-6.2 6.2",
      class: "st0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M10.3 16.1V9.2l6 3.4z",
      class: "st0"
    }, null, -1)
  ])))
}
export default { render: render }